import { signInWithPopup } from "firebase/auth";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, provider } from "../../../firebase";
import google from "../fitness/landing/tracker/google.png";

const LoginPageFood: React.FC = () => {
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log("✅ Logged in as:", user.displayName);
      navigate("/foodbudget");
    } catch (error) {
      console.error("❌ Login error:", error);
    }
  };

  useEffect(() => {
    if (auth.currentUser) {
      navigate("/foodbudget");
    }
  }, [navigate]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.title}>Welcome to Food Budget Tracker</h1>

        <p style={styles.subtitle}>No sign-up required. Just log in.</p>
        <button onClick={handleLogin} style={styles.googleButton}>
          <img src={google} alt="Google" style={styles.icon} />
          Continue with Google
        </button>
        <p style={styles.disclaimer}>
          We do not store your name, email, or any personal info.
        </p>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    padding: "2rem",
  },
  card: {
    maxWidth: "400px",
    width: "100%",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    border: "1px solid #e5e7eb",
    textAlign: "center" as const,
  },
  title: {
    fontSize: "1.875rem",
    fontWeight: 600,
    marginBottom: "0.5rem",
    color: "#111827",
  },
  subtitle: {
    fontSize: "1rem",
    color: "#6b7280",
    marginBottom: "2rem",
  },
  googleButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "12px 16px",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    color: "#333",
    cursor: "pointer",
    transition: "box-shadow 0.2s ease-in-out",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  },
  icon: {
    width: "20px",
    height: "20px",
    marginRight: "10px",
  },
  disclaimer: {
    fontSize: "0.85rem",
    color: "#6b7280",
    marginTop: "1.5rem",
    lineHeight: 1.4,
  },
};

export default LoginPageFood;
